<template>
  <div :class="`card-tag card-tag-${name}`" :style="`background: ${color()}` ">{{ text }}</div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: [String]
    },
    text: {
      required: true,
      type: [String]
    }
  },
  methods: {
      color() {
          if(this.name == 'discount') {
            let discount =  parseInt(this.text) * -1;

            if(0 < discount && discount < 30)
              return '#f67272';
            else if(30 <= discount && discount < 40)
              return '#FCDC4B';
            else if(40 <= discount && discount < 50)
              return '#60C0BF';
            else if(50 <= discount && discount < 60)
              return '#9aca3d';
            else if(60 <= discount && discount < 70)
              return '#ea8d31';
            else if(70 <= discount)
              return '#ea8d31';
          }
      }
  }
}
</script>
